import { cn } from "@/lib/utils";
import { INDEX_ICON } from "./indexIcon";

/**
 * The shared number/letter circle used by list-style blocks (accordion,
 * checklist, steps, poll, quiz). Colours come from the lomda theme — never a
 * per-block hardcoded colour — so every badge follows the theme automatically.
 * See STANDARDS-LOMDA-V3.md §0/§3.
 */
export function IndexBadge({
    children,
    active = false,
    size = "size-8",
    textClass = INDEX_ICON.numberText,
    background,
    className,
}: {
    children: React.ReactNode;
    /** Filled/active state (selected, checked, current). */
    active?: boolean;
    /** Tailwind size class, e.g. "size-8" | "size-6". */
    size?: string;
    /** Typography preset for the number/letter (default: H6, per INDEX_ICON). */
    textClass?: string;
    /** Optional custom (inactive) background — defaults to the theme background.
     *  Lets a block expose a "number background" appearance control. */
    background?: string;
    className?: string;
}) {
    return (
        <span
            className={cn(
                "flex shrink-0 items-center justify-center rounded-full transition",
                size,
                textClass,
                className
            )}
            style={
                active
                    ? {
                          backgroundColor: INDEX_ICON.badgeActiveBg,
                          color: INDEX_ICON.badgeActiveText,
                      }
                    : {
                          backgroundColor: background ?? INDEX_ICON.badgeBg,
                          color: INDEX_ICON.badgeText,
                      }
            }
        >
            {children}
        </span>
    );
}
